/**
 * URL builders for owner-dashboard routes. Keeps path strings in one place so
 * a future route restructure doesn't require grepping for literals.
 */

export const ORDERS_LIST_PATH = (restaurantId: string) =>
  `/app/restaurants/${restaurantId}/orders`;

export const ORDERS_HISTORY_PATH = (restaurantId: string) =>
  `${ORDERS_LIST_PATH(restaurantId)}/history`;

export const ORDER_DETAIL_PATH = (restaurantId: string, orderId: string) =>
  `${ORDERS_LIST_PATH(restaurantId)}/${orderId}`;

/** Matches the detail page for a specific order id. */
export function isOrderDetailPath(
  pathname: string,
  restaurantId: string,
  orderId: string
): boolean {
  const prefix = ORDERS_LIST_PATH(restaurantId);
  if (!pathname.startsWith(prefix)) return false;
  const rest = pathname.slice(prefix.length);
  if (rest === '' || rest === '/') return false;
  const match = rest.match(/^\/([^/?#]+)/);
  return !!(match && match[1] === orderId);
}

/** Matches the orders list page (no order id segment). */
export function isOrdersListPath(pathname: string, restaurantId: string): boolean {
  const prefix = ORDERS_LIST_PATH(restaurantId);
  return pathname === prefix || pathname === `${prefix}/`;
}

/** Matches any route under /orders for this restaurant (list or detail). */
export function isUnderOrdersScope(pathname: string, restaurantId: string): boolean {
  return pathname.startsWith(ORDERS_LIST_PATH(restaurantId));
}
